export default __webpack_public_path__ + "static/media/image 3.c438e757.svg";